'use client';

import React, { useState, useEffect } from 'react';
import { tv } from 'tailwind-variants';
import ButtonWrapper from 'helpers/SitecoreWrappers/ButtonWrapper/ButtonWrapper';
import LinkWrapper from 'helpers/SitecoreWrappers/LinkWrapper/LinkWrapper';
import { useUIText } from '../../hooks/useUIText';
import { LinkFieldValue } from '@sitecore-content-sdk/nextjs';
interface StepNavigationProps {
  currentStepId?: string;
  canGoBack: boolean;
  isLastStep: boolean;
  isSubmitting: boolean;
  onBack: () => void;
  onNext: () => void;
  showSkipCTA?: boolean;
}

export const StepNavigation: React.FC<StepNavigationProps> = ({
  currentStepId,
  canGoBack,
  isLastStep,
  isSubmitting,
  onBack,
  onNext,
  showSkipCTA = false,
}) => {
  const { getButtonText } = useUIText();
  const [backToLandingPageUrl, setBackToLandingPageUrl] = useState<LinkFieldValue>({ href: '/' });

  const { container, buttonBase } = TAILWIND_VARIANTS();
  const submitButtonText =
    currentStepId === 'step-9-1-confirmation'
      ? 'Confirm & submit'
      : getButtonText('submit', 'Submit');
  const nextButtonText =
    currentStepId === 'step-8-9-estate-beneficiaries-summary'
      ? getButtonText('completeThisSection', 'Complete this section')
      : getButtonText(showSkipCTA ? 'skip' : 'next', showSkipCTA ? 'Skip' : 'Next');
  const isCapacityConcernStep = currentStepId && currentStepId === 'step-1-capacity' ? true : false;

  useEffect(() => {
    if (!isCapacityConcernStep) return;

    const currentUrl = new URL(window.location.href);
    const segments =
      currentUrl && currentUrl.pathname ? currentUrl.pathname.split('/').filter(Boolean) : [];
    segments.pop();
    const cleanPath = '/' + segments.join('/');
    setBackToLandingPageUrl({
      target: '_self',
      text: 'Back',
      href: cleanPath ? cleanPath : '/',
    });
  }, [isCapacityConcernStep]);

  return (
    <div className={container()}>
      {isCapacityConcernStep ? (
        <LinkWrapper
          field={{ value: backToLandingPageUrl }}
          ctaComponentClass="default"
          ctaVariant="secondary"
          suppressNewTabIcon={true}
          className={buttonBase()}
        />
      ) : (
        <ButtonWrapper
          type="button"
          text={getButtonText('back', 'Back')}
          ctaComponentClass="default"
          ctaVariant="secondary"
          onClick={onBack}
          disabled={!canGoBack}
          className={buttonBase()}
        />
      )}
      {!isLastStep ? (
        <ButtonWrapper
          type="button"
          text={nextButtonText}
          ctaComponentClass="default"
          ctaVariant="primary"
          onClick={onNext}
          disabled={isSubmitting}
          ctaIconAlignment="right"
          ctaIcon="arrow-right"
          ctaIconSize="xs"
          className={buttonBase()}
        />
      ) : (
        <ButtonWrapper
          type="submit"
          text={submitButtonText}
          ctaComponentClass="default"
          ctaVariant="primary"
          disabled={isSubmitting}
          ctaIconAlignment="right"
          ctaIcon="arrow-right"
          ctaIconSize="xs"
          className={buttonBase()}
        />
      )}
    </div>
  );
};

const TAILWIND_VARIANTS = tv({
  slots: {
    container: ['flex', 'flex-row', 'flex-start', 'gap-space-between-less'],
    buttonBase: ['!w-fit', 'leading-[100%]', 'md:leading-[100%]', 'lg:leading-[100%]', 'h-12'],
  },
});
